export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/automated-planning-group`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        users: {
            method: 'GET',
            isArray: true,
            url: `${baseUrl}/users`
        },
        addUsersIndex: {
            method: 'GET',
            isArray: true,
            url: `${baseUrl}/users-add-index`
        },
        addUsers: {
            method: 'POST',
            isArray: true,
            url: `${url}/add-users`
        },
        removeUsers: {
            method: 'POST',
            isArray: true,
            url: `${url}/remove-users`
        },
        setTargets: {
            method: 'POST',
            url: `${url}/set-targets`
        },
        generationProgress: {
            method: 'GET',
            url: `${url}/generation-progress`
        },
        delete: {
            method: 'DELETE',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/AutomatedPlanningGroup/index.js